/**
 * @name elements
 * @description
 * Build and work with HTML elements of the DOM
 */
export default class Elements {

    constructor() {}

    /**
     * @name buildElement
     * @description
     * Build a div container to insert attach a VUE module
     * @param [string] [conf.id] Element of id
     * @param [string] [conf.parent] Parent of element where attach the new element
     * @param [string] [conf.parentType] Parent element type
     */
    build(conf = {}) {
        const { id, parent, insertType } = conf;

        // Create new element
        let iDiv = document.createElement('div');
        iDiv.id = id;

        // Instance Element
        const elm = (() => {

          // Detect parent Type
          const parentSplit = parent.split(' ').length;
          const parentType = parent.startsWith('#') && parentSplit === 1 ? 'id' : parent.startsWith('.') || parent.startsWith('#') ? 'class' : 'tagname';

          switch (parentType) {
              case 'id':
                  return document.getElementById(parent.replace('#',''));
              case 'tagname':
                  return document.getElementsByTagName(parent)[0];
              case 'class':
                  return document.querySelectorAll(parent)[0];
              default:
                  break;
          }
        })();
        if(!elm) return;
        // Insert New Element
        switch (insertType) {
          case 'appendChild':
              elm.appendChild(iDiv);
            break;
          case 'insertBefore':
              elm.insertBefore(iDiv, elm.firstChild);
            break;
            case 'insertAfter':
              elm.parentNode.insertBefore(iDiv, elm.nextSibling);
            break;
          default:
              elm.appendChild(iDiv);
            break;
        }
    }

    /**
     * @name drag
     * @description: Function to dragg the elements into the DOM
     * @param [obj] element to drag
     */
    drag(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if(!elmnt) return;
        if (document.getElementById(elmnt.id + "header")) {
          // if present, the header is where you move the DIV from:
          document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
        } else {
          // otherwise, move the DIV from anywhere inside the DIV:
          elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
          e = e || window.event;
        //   e.preventDefault();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
          e = e || window.event;
        //   e.preventDefault();
          // calculate the new cursor position:
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
          elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
          // stop moving when mouse button is released:
          document.onmouseup = null;
          document.onmousemove = null;
        }
    }
    /**
     * Move elemento to other place
     * @param {string class or id with . or #} nameChildren
     * @param {string class or id with . or #} nameParent
     * @param {string position first,last, before or after - default last } position
     * @usage ex. moveElementTo('.energy-usage-label', '.content', 'first');
     *
     */
    moveElementTo(nameChildren, nameParent, position = 'last') {
      const parentType = nameParent.startsWith('#') ? 'id' : nameParent.startsWith('.') ? 'class' : 'tagname',
      childrenType = nameChildren.startsWith('#') ? 'id' : nameChildren.startsWith('.') ? 'class' : 'tagname',
      elementParent = getElementDOM(parentType, nameParent),
      elementChildren = getElementDOM(childrenType, nameChildren);
      (elementParent && elementChildren) ? getPosition(elementParent, elementChildren, position): null;

      function getElementDOM(type, nameElement) {
        switch (type) {
          case 'id':
            return document.getElementById(nameElement.replace('#', ''));
          case 'tagname':
            return document.getElementsByTagName(nameElement)[0];
          case 'class':
            return document.querySelectorAll(nameElement)[0];
          default:
            return null;
        }
      }

      function getPosition(elementParent, elementChildren, position) {
        switch (position) {
          case 'first':
            elementParent.insertBefore(elementChildren, elementParent.firstChild);
            break;
          case 'before':
            elementParent.insertBefore(elementChildren, elementParent.firstChild);
            break;
          case 'after':
            elementParent.parentNode.insertBefore(elementChildren, elementParent.nextSibling);
            break;
          case 'last':
            elementParent.appendChild(elementChildren);
            break;
          default:
            null;
            break;
        }
      }
    }
  }